import loginPrompt from './loginPrompt';
import { ruleConfigTradeOnboarding } from './tradeOnboarding';
import mobileAds from './mobileAds';
import abandonCheckout from './abandonCheckout/index';
import collabPurchasing from './collaborativePurchasing';

export default [
    loginPrompt,
    ruleConfigTradeOnboarding,
    mobileAds,
    collabPurchasing,
    ...abandonCheckout,
];



// WEBPACK FOOTER //
// ./src/notificationQueue/globalNotifications/index.js